<template functional>
  <div>
    <a
      v-if="props.options.isImport(props.item)"
      :data-action="'showPickups'"
      :data-order-id="props.item.id"
    >
      <div
        class="cname"
        v-for="(str, index) in props.options.splitStr(props.item.terminals)"
        :key="index"
      >
        {{ str }}
      </div>
    </a>
    <template v-else>
      <div
        v-for="(str, index) in props.options.splitStr(props.item.terminals)"
        :key="index"
        class="cname"
      >
        {{ str }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "drayage-terminals",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
